import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import {
  toggleConfirmPopup,
  setJobId
} from "../../actions/actionFunctions";
import {
  showContractSigning,
  setAfterContractSignCallback
} from "../../actions/contractsActions";
import {updateSQFT} from "../../actions/sqftFunctions";
import {ConfirmPopupTypes, QuoteRequestType, SqftUpdateTypes, UserAction} from "../visComponents/constants";
import {setUserLoginResponse, userLogin, userRegister} from "../../api/user-api";
import Analytics from './../../analytics';
import WithCloseSQFtCalc from "../sqft/hocs/withCloseSQFtCalc";
import workspace from "../sqft/components/canvas/core/workspace";
import WithOverlay from "./withOverlayHoc";
import {setAssignQuotePopupCustomer} from "../../actions/assignPopupFunctions";
import {setAlreadyRegisteredUserInfo} from "../../actions/userFunctions";
import {loaderEnable} from "../ui/loaderView";
import {renderConfirmPopup} from "../../api/api-popups";
import {ROUTES} from "../../routes";

class ConfirmPopup extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.applyPopupOpened && !this.props.applyPopupOpened) {
      document.body.classList.add('body--apply-popup');
    }
  }

  handleApply = (confirm, hideOverlay, closeSQFtCalc) => {
    // Analytics.sendClickEvent('confirm-popup-apply-' + (confirm ? 'yes': 'no'));
    hideOverlay(this.closePopup);
    document.body.classList.remove('body--apply-popup');
    const {confirmPopupType, confirmPopupTag} = this.props;
    switch (confirmPopupType) {
      case ConfirmPopupTypes.ConsultationRequest: {
        const data = {
          yesNoConsultationRequest: confirm,
          userPopupType: confirmPopupTag.userPopupType,
          fromConfirmationDialog: true,
          quoteRequestType: QuoteRequestType.RequestConsultation
        };
        confirm
          ? Analytics.sendClickEvent('design-consultation-yes')
          : Analytics.sendClickEvent('design-consultation-no');
        switch (confirmPopupTag.userAction) {
          case UserAction.Login:
            userLogin(data);
            break;
          case UserAction.Register:
            userRegister(data)
            break;
        }
        break;
      }
      case ConfirmPopupTypes.SqftResetChanges: {
        if (confirm) {
          this.props.updateSQFT(SqftUpdateTypes.Reset);
          closeSQFtCalc(false);
          workspace.removeAllShapes();
          workspace.textBoxManager.removeAllTextBoxes();
          workspace.removeAllSlabImages();
          setTimeout(() => {
            this.props.updateSQFT(null);
          }, 0)
        }
        break;
      }
      case ConfirmPopupTypes.SqftUpdateQuestion: {
        if (confirm) {
          this.props.updateSQFT(SqftUpdateTypes.UpdateData);
          setTimeout(() => {
            this.props.updateSQFT(null);
          }, 0)
        }
        break;
      }
      case ConfirmPopupTypes.AssignQuoteOnExistingUser: {
        if (confirm) {
          const {alreadyRegisteredUserInfo} = this.props;
          Analytics.sendClickEvent('confirm-assign-quote-on-existing-user');
          if (window.location.hash.includes(ROUTES.contract)) {
            // this.props.showContractSigning(false, () => {}); // why close contract?
            if (this.props.afterContractSignCallback) {
              this.props.setAfterContractSignCallback(null);
            }
          }
          if (alreadyRegisteredUserInfo.assignQuote) {
            this.props.setAssignQuotePopupCustomer({ // clear current selected customer
              id: alreadyRegisteredUserInfo.userId,
              email: alreadyRegisteredUserInfo.email,
              fullName: alreadyRegisteredUserInfo.values.firstName + (alreadyRegisteredUserInfo.values.lastName ? " " + alreadyRegisteredUserInfo.values.lastName : ""),
            });
            this.props.setAlreadyRegisteredUserInfo({confirmedAssign: true}); // trigger assign quote button
          } else {
            loaderEnable();
            setUserLoginResponse(alreadyRegisteredUserInfo, true);
          }
        }
        if (confirmPopupTag.applyFunction) {
          confirmPopupTag.applyFunction();
        }
        break;
      }
      case ConfirmPopupTypes.DeleteCartItemsPopup: {
        if (confirm) {
          renderConfirmPopup(0, {allowDelete: true}, false); // clear tag
        }
        break;
      }
      // case ConfirmPopupTypes.ChangeWizardToPreviousStepSelection:
      // case ConfirmPopupTypes.ReplaceRoomWhenItExistsInCartButWeAddNew: {
      //   break;
      // }
      default: {
        if (confirm) {
          if (confirmPopupTag.applyFunction) {
            confirmPopupTag.applyFunction();
          }
        } else if (confirmPopupTag.declineFunction) {
          confirmPopupTag.declineFunction()
        }
        renderConfirmPopup(0, {}, false); // clear tag
        break;
      }
    }
  };

  getConfirmMessage = () => {
    const {intl, confirmPopupType, confirmPopupTag} = this.props;
    switch (confirmPopupType) {
      case ConfirmPopupTypes.ConsultationRequest:
        return intl.formatMessage({id: "confirmPopup.consultationRequest"});
      case ConfirmPopupTypes.SqftResetChanges:
        return intl.formatMessage({id: "confirmPopup.sqftResetChanges"});
      case ConfirmPopupTypes.SqftUpdateQuestion:
        return intl.formatMessage({id: "confirmPopup.sqftUpdateQuestion"});
      case ConfirmPopupTypes.DeleteCartItemsPopup:
        return intl.formatMessage({id: confirmPopupTag.fromDelete ? "confirmPopup.deleteCartItems2" : "confirmPopup.deleteCartItems"});
      case ConfirmPopupTypes.ChangeWizardToPreviousStepSelection:
        return intl.formatMessage({id: "confirmPopup.deleteCartItemsWizard"});
      case ConfirmPopupTypes.ReplaceRoomWhenItExistsInCartButWeAddNew:
        return intl.formatMessage({id: "confirmPopup.replaceRoomWhenItExistsInCartButWeAddNew"});
      case ConfirmPopupTypes.AssignQuoteOnExistingUser: {
        const {alreadyRegisteredUserInfo} = this.props;
        return (
          <Fragment>
            <p><FormattedMessage id="confirmPopup.assignQuoteOnExistingUser1"/></p>
            <p><FormattedMessage id="confirmPopup.assignQuoteOnExistingUser2"/></p>
            {alreadyRegisteredUserInfo.values ? (
              <div className="confirm-popup-body__user bold">
                <p>{alreadyRegisteredUserInfo.values.firstName + (alreadyRegisteredUserInfo.values.lastName ? " " + alreadyRegisteredUserInfo.values.lastName : "")}</p>
                <p>{alreadyRegisteredUserInfo.email}</p>
              </div>
            ) : null}
          </Fragment>
        );
      }
      default:
        return "Text is not set up"
    }
  };

  closePopup = () => {
    this.props.toggleConfirmPopup(false);
  };

  render() {
    const {confirmPopupOpened, confirmPopupType} = this.props;
    if (!confirmPopupOpened) {
      return null
    }
    return (
      <WithOverlay className="overlay--confirm">
        {(hideOverlay) => (
          <div className={"confirm-popup confirm-popup--" + confirmPopupType}>
            {/*<div className="apply-popup-header">*/}
            {/*<h3 className="apply-popup-header__title bold">Would you like to add any visualized items to your cart?</h3>*/}
            {/*<button className="apply-popup-header__close ui-close" onClick={this.handleConfirmPopupToggle}/>*/}
            {/*</div>*/}
            <div className="confirm-popup-body">
              {this.getConfirmMessage()}
            </div>
            <div className="confirm-popup-buttons">
              <button className="ui-button2 ui-button2--blue" onClick={() => this.handleApply(false, hideOverlay)}>
                <FormattedMessage id={confirmPopupType === ConfirmPopupTypes.AssignQuoteOnExistingUser
                  ? "confirmPopup.buttonCancel" : "confirmPopup.buttonNo"}/>
              </button>
              <WithCloseSQFtCalc props={this.props}>
                {(closeSQFtCalc) => (
                  <button className="ui-button2 ui-button2--green" onClick={() => this.handleApply(true, hideOverlay, closeSQFtCalc)}>
                    <FormattedMessage id="confirmPopup.buttonYes"/>
                  </button>
                )}
              </WithCloseSQFtCalc>
            </div>
          </div>
        )}
      </WithOverlay>

    )
  }
}

const mapStateToProps = (store) => {
  const {confirmPopupOpened, confirmPopupType, confirmPopupTag, alreadyRegisteredUserInfo} = store.userState;
  const {afterContractSignCallback} = store.contractSigningState;
  return {
    confirmPopupOpened,
    confirmPopupType,
    confirmPopupTag,
    alreadyRegisteredUserInfo,
    // contractSignIsOpened: isVisible,
    afterContractSignCallback,
  };
};
const mapDispatchToProps = {
  toggleConfirmPopup,
  setJobId,
  updateSQFT,
  setAssignQuotePopupCustomer,
  setAlreadyRegisteredUserInfo,
  showContractSigning,
  setAfterContractSignCallback,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ConfirmPopup)
)
